module.exports = {
    // 导航栏
    navbar: {
        HOME: '首页',
        ABOUT: '关于',
        ABOUTUS: '关于我们',
        EDITORIAL: '编辑政策',
        POLICY: '开放获取',
        NEWS: '新闻',
        PAYMENT: 'APC付款',
        JOURNALS: '期刊',
        CJOURNALS: '中文期刊',
        EJOURNALS:'英文期刊',
        SPECIALISSUES: '特殊期刊',
        SPECIALISSUESINFO:'特殊期刊详情',
        BOOKS: '图书/专著',
        ACABOOKS: '学术类',
        LITABOOKS: '文艺作品与教材',
        CONTACT: '联系我们',
        CONFERENCE: '会议',
        MORE: '了解更多',
        Email: '邮箱',
        Location: '地址',
        LOGIN: '登录',
        Search: '搜索'
    },
    // 底部
    footer: {
        CONTACTUS: '联系我们',
        WEBSITENAVIGATION: '网站地图',
        ABOUTUS: '关于我们',
        OURSERVICES: '主营业务',
        NEWS: '最新资讯',
        LIVERATE: '实时汇率',
        CUSTOMERSERVICE: '客服热线',
        WECHAT: '微信公众号'
    },
    // 首页
    index: {
        SERVICES: '主营业务',
        NEWS: '最新资讯',
        GOLDMATENEWS: '公司要闻',
        MARKETINSIGHT: '汇市动态',
        KUNDAX: '坤达速汇',
        GOLDMATE: '中联汇兑',
        GOLDMATEGROUP: '中联集团介绍',
        KUNDAGROUP: '坤达集团介绍'
    }
}


// WEBPACK FOOTER //
// ./src/common/lang/zh.js